"use client"

import { CounterBadge } from "@/app/nft/counter/badge"
import { Skeleton } from "@rarible_int/anaconda_ui_components"
import { reatomComponent } from "@reatom/react"
import { useSuspenseQuery } from "@tanstack/react-query"
import { useMolecule } from "bunshi/react"
import { Suspense } from "react"
import { ErrorBoundary } from "react-error-boundary"
import { ProfileNftsCountMoleculeReatom } from "./store.reatom"

export const ProfileNftsCounterBadgeReatom = reatomComponent(() => {
  return (
    <ErrorBoundary fallback={null}>
      <Suspense fallback={<Skeleton className="h-5 w-[30px]" />}>
        <ProfileItemsCounterReatom />
      </Suspense>
    </ErrorBoundary>
  )
}, "ProfileNftsCounterBadgeReatom")

const ProfileItemsCounterReatom = reatomComponent(() => {
  const { queryParamsAtom } = useMolecule(ProfileNftsCountMoleculeReatom)

  // Call atom directly in Reatom v1000
  const queryParams = queryParamsAtom()
  const { data: count } = useSuspenseQuery(queryParams)

  return (
    <CounterBadge
      data-testid="profile-items-amount"
      data-amount={count}
      count={count}
    />
  )
}, "ProfileItemsCounterReatom")
